export default {
  init() {
    this.handleUrls();
  },
  handleUrls() {
    // Stop WP from re-writing resource-centre urls
    let ancs = $('.page-container').find('a');

    let replaceAncs = $('.hidden-container').find('a');
    let repUrls = [];
    $(replaceAncs).each(function () {
      repUrls.push($(this).attr('href'));
    });

    $(ancs).each(function (index) {
      if ($(this).attr('href').includes('category')) {
        $(this).attr('href', repUrls[index]);
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singlePressRelease.js